<script lang="ts">
  import MediaPreview from './media/MediaPreview.svelte';
  import PostStatsRow from './PostStatsRow.svelte';
  import UserAvatarWrapper from './user/userAvatarWrapper.svelte';
  import { PostsCore } from '$src/utils/postsCore.util';
  import { me } from '$stores/user.store';
  import type { FPost, WithCreatorData } from 'garden-common';

  import Rank from './Rank.svelte';
  import { truncate } from '$src/utils/helpers.util';
  import { openPostInModal } from '$src/stores';
  import SaveToGallery from '../Modals/gallery/SaveToGallery.svelte';
  import CreateGallery from '../Modals/gallery/CreateGallery.svelte';
  import AddToGallery from '../Modals/gallery/AddToGallery.svelte';
  import DeletePostModal from '../CreatePost/DeletePostModal.svelte';
  import DonateModal from '../CreatePost/DonateModal.svelte';
  import PostCatsRow from './PostCatsRow.svelte';
  import { goto } from '$app/navigation';

  export let type: string;

  export let hideAuthor = false;
  export let post: Partial<FPost<string>> & Partial<WithCreatorData>;

  export let containerCls = '';

  export let rank: number | null = null;
  export let badge: string | null = null;
  const core = new PostsCore($me, post);

  $: creatorData = post?.creatorData;

  openPostInModal.subscribe(() => {
    if (!$openPostInModal) {
      setPost();
    }
  });

  async function handleReceiveMediaClickEvent() {
    // Do a goto since the core.onPreviewPost() is not handled by the challenges page
    // and does not show a modal for easy access.
    if (type === 'challenge' || type === undefined) {
      goto(`/post/${post._id}`, { replaceState: true });
    } else {
      await core.onPreviewPost();
    }
  }

  async function setPost() {
    post = core.getPost();
  }
</script>

{#if core.openModal === 'save-to-gallery'}
  <SaveToGallery
    postId={post?._id}
    on:ModalClose={() => (core.openModal = null)}
    on:Saved={() => {
      core.SavePostToGallery();
      setPost();
    }}
    on:OpenCreateGallery={() => {
      core.OpenCreateGallery();
      setPost();
    }}
  />
{:else if core.openModal === 'create-gallery'}
  <CreateGallery
    {post}
    on:GalleryCreated={() => {
      core.openModal = core.CloseCreateGallery();
    }}
    on:ModalClose={() => {
      core.openModal = core.CloseCreateGallery();
    }}
  />
{:else if core.openModal === 'add-to-gallery'}
  <AddToGallery
    on:ModalClose={() => {
      core.openModal = core.Close();
    }}
    on:AddedToGalleries={() => {
      core.openModal = core.Close();
    }}
  />
{:else if core.openModal === 'delete-post'}
  <DeletePostModal
    on:DeletePost={async () => {
      core.openModal = core.Close();
      await core.DeletePost();
    }}
    {post}
    on:ModalClose={() => {
      core.openModal = core.Close();
    }}
  />
{:else if core.openModal === 'donation-post'}
  <DonateModal
    on:Donate={e => {
      core.Donation(e);
      setPost();
    }}
    {post}
    on:ModalClose={() => {
      core.openModal = core.Close();
    }}
  />
{/if}

<div
  class="{containerCls} h-fit bg-white --updated-border rounded-xl overflow-hidden hover:shadow-island cursor-pointer duration-200 w-full tc-post"
>
  {#if !hideAuthor}
    <div class="flex justify-between relative">
      <button
        class="flex gap-x-2 px-3 items-center pt-3 mb-4"
        on:click={() => {
          core.openModal = core.Close();
          core.onViewProfile();
        }}
      >
        <div class="bg-gray-100 rounded-full w-8 aspect-square">
          <UserAvatarWrapper
            cls={'w-8 h-8 gap-3 '}
            profileImage={creatorData?.profileImage}
            userName={creatorData?.userName}
          />
        </div>

        <div class="font-medium hover:underline text-[#55697E] empty:bg-gray-100 h-6 rounded">
          {truncate(creatorData?.name, 25) || 'Deleted'}
        </div>
      </button>
      {#if badge}
        <div class="absolute right-2 -top-1">
          <Rank slot={true}><img class="w-10 h-10" src={badge} alt="" srcset="" /></Rank>
        </div>
      {:else if rank}
        <div class="absolute right-2 -top-1">
          <Rank value={rank} />
        </div>
      {/if}
    </div>
  {/if}

  <div class="aspect-square bg-black">
    <MediaPreview on:clickedMedia={handleReceiveMediaClickEvent} {post} />
  </div>

  <div class="mt-4 pl-4 pr-1">
    <div class="flex items-center gap-2">
      <div
        class="text-blueish-grey-900 font-bold text-base empty:bg-gray-100 empty:h-7 rounded-lg truncate w-full"
        title={post?.title || ''}
      >
        {post?.title || ''}
      </div>

      <div class="flex-grow" />
    </div>

    <div class="pt-2">
      <PostCatsRow {post} />
    </div>

    <div class="pb-3 mt-4">
      <PostStatsRow
        {post}
        on:donate={() => {
          core.onDonate();
          setPost();
        }}
        on:appreciate={() => {
          core.onAppreciate();
          setPost();
        }}
        on:comment={async () => {
          core.onComment();
          setPost();
        }}
        on:save={() => {
          core.onSave();
          setPost();
        }}
      />
    </div>
  </div>
</div>
